export const DEV_MODE = window.location.search.includes("dev");

export const MAP_MODE = window.location.search.includes("map");

export const PERF_MODE = window.location.search.includes("perf");

// Performance optimization constants
export const PERFORMANCE = {
  // Target FPS to maintain
  TARGET_FPS: 60,
  
  // Shadow quality settings
  SHADOWS: {
    HIGH: [2048, 2048],
    MEDIUM: [1024, 1024],
    LOW: [512, 512],
  },
  
  // LOD distance thresholds
  LOD: {
    HIGH_DETAIL_DISTANCE: 10,
    MEDIUM_DETAIL_DISTANCE: 30,
    LOW_DETAIL_DISTANCE: 60,
  },
  
  // Enable automatic performance adjustments
  AUTO_ADJUST: true,
  
  // Low performance mode (can be enabled with ?low-perf in URL)
  LOW_PERFORMANCE_MODE: window.location.search.includes("low-perf"),
};
